import { HTMLGenricComponent } from "./../htmlComponent/HTML-Genric-Component.JSON";

export class QuestionRequestJSON {
    questionID: Number;
    sequence: Number;
    questionTextComponentJSON: HTMLGenricComponent;

    constructor() {
        this.questionTextComponentJSON = new HTMLGenricComponent;
    }
}